import React, { useState, useContext, useEffect } from 'react';
import { FaCheck } from "react-icons/fa";
import { ClubFittingContext } from "../../ClubfittingNew/ClubFittingContext";

function ImageUpload({ step , title }) {

    const { remotefittingdata, setRemotefittingdata, updateremotefitting, remotefittingimage, setRemotefittingimage, updateremotefittingfile } = useContext(ClubFittingContext);
    const [isLoading, setIsLoading] = useState(false);

    const [imageURL, setImageURL] = useState(null);


    console.log("**remotefittingdata", remotefittingimage);
    console.log("**step", step);
    console.log("**imageURL", imageURL);
    console.log("remotefittingdata", remotefittingdata[step].preferred_club);
    

    const handleImageChange = (e) => {
        setIsLoading(true);
        const image = e.target.files[0];
        setImageURL(URL.createObjectURL(image));
        updateremotefittingfile(step + '.location', image);
        setIsLoading(false);
    };

    const updatebutton = (buttonnumber) => {
        updateremotefitting(`${step}.preferred_club`, `${buttonnumber}`);
    }

    useEffect(() => {
        if (remotefittingimage[step]?.location instanceof File) {
            setImageURL(URL.createObjectURL(remotefittingimage[step].location));
        }else {
            setImageURL(null);
        }
    }, [step ,remotefittingimage]);


    return (
        <>
            {/* <div className="border-sec">
                <div className="sec-header-dash border-header-sec white">
                    <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                        <h3 className="box-title-lable">
                            <span className="color-image">
                                <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                                    width="64.000000pt" height="64.000000pt" viewBox="0 0 64.000000 64.000000"
                                    preserveAspectRatio="xMidYMid meet">

                                    <g transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
                                        fill="#ffffff" stroke="none">
                                        <path d="M245 631 c-92 -24 -173 -90 -215 -176 -33 -69 -34 -199 -2 -265 35
                                    -71 75 -114 144 -151 58 -31 70 -34 148 -33 72 0 93 4 136 26 75 40 107 70
                                    145 140 31 58 34 70 34 148 0 78 -3 90 -34 148 -57 104 -144 160 -260 167 -36
                                    2 -79 1 -96 -4z m135 -141 c11 -11 20 -24 20 -29 0 -5 18 -11 39 -15 60 -9 71
                                    -32 71 -148 0 -140 2 -138 -190 -138 -192 0 -190 -2 -190 138 0 116 11 139 71
                                    148 21 4 39 10 39 15 0 23 42 49 80 49 27 0 47 -7 60 -20z"/>
                                        <path d="M294 413 c-12 -2 -34 -17 -49 -33 -39 -41 -39 -100 1 -141 23 -24 36
                                    -29 74 -29 38 0 51 5 74 29 71 74 2 193 -100 174z m81 -48 c16 -15 25 -36 25
                                    -55 0 -70 -86 -105 -135 -55 -50 49 -15 135 55 135 19 0 40 -9 55 -25z"/>
                                    </g>
                                </svg>
                            </span>
                            Strike Locations
                        </h3>
                    </div>
                    <div className="content-box-btn">
                        <div className={`head_check ${remotefittingimage && remotefittingimage[step] && remotefittingimage[step].location ? 'active' : ''}`}>
                            <FaCheck />
                        </div>
                    </div>
                </div>
                <div className="desc">
                    <p>Upload a photo below with all three club faces of this color category for us to analyze your strike locations.</p>
                </div>

                <div className="card-image">
                    <div className="drop_box">
                        <input
                            type="file"
                            accept=".jpg,.jpeg,.png,.gif"
                            id={`${step}.imageid`}
                            style={{ display: 'none' }}
                            onChange={handleImageChange}
                        />
                        {
                            isLoading ? (
                                <div>Loading...</div> // Replace this with your loader component
                              ) : 
                            imageURL && (
                                <div className="form">
                                    <img
                                        className='uploaded-image'
                                        key={imageURL}
                                        src={imageURL}
                                        alt="selectedImage"
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            )

                        }
                        <div className="custom-upload-btn">
                            <button className="btn btn-upload-image" onClick={() => document.getElementById(`${step}.imageid`).click()}>
                                { imageURL && !isLoading ? 'Change Photo' : 'Add Photo'}
                            </button>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="border-sec">
                <div className="sec-header-dash border-header-sec white">
                    <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                        <h3 className="box-title-lable">
                            <span className="color-image">
                                <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                                    width="64.000000pt" height="64.000000pt" viewBox="0 0 64.000000 64.000000"
                                    preserveAspectRatio="xMidYMid meet">

                                    <g transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
                                        fill="#ffffff" stroke="none">
                                        <path d="M265 581 c-211 -55 -282 -313 -124 -455 54 -49 103 -68 179 -69 104
                                    -1 187 51 238 148 67 129 2 304 -132 360 -43 18 -123 26 -161 16z m88 -167
                                    c50 21 97 -6 97 -55 0 -31 -104 -159 -130 -159 -26 0 -130 128 -130 159 0 49
                                    47 76 98 55 26 -11 38 -11 65 0z"/>
                                    </g>
                                </svg>
                            </span>
                            Preferred Club
                        </h3>
                    </div>
                    <div className="content-box-btn">
                        <div className={`head_check ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step].preferred_club ? 'active' : ''}`}>
                            <FaCheck />
                        </div>
                    </div>
                </div>
                <div className="desc">
                    <p>Tell us what club that felt best to you while testing this color by selecting it below. This is 100% preference.</p>
                </div>
                <div className='btn-sec'>
                    <div className='btn-list'>
                        <button className={`btn btn-colr-white ${remotefittingdata[step].preferred_club === "1" ? 'active' : ''}`} onClick={() => updatebutton(1)}>Iron 1</button>
                        <button className={`btn btn-colr-white ${remotefittingdata[step].preferred_club === "2" ? 'active' : ''}`} onClick={() => updatebutton(2)}>Iron 2</button>
                        <button className={`btn btn-colr-white ${remotefittingdata[step].preferred_club === "3" ? 'active' : ''}`} onClick={() => updatebutton(3)}>Iron 3</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ImageUpload;